export default __webpack_public_path__ + "static/media/ic_sun.3c159369.svg";